<template>
  <div class="col-md-12">
    <div v-for="(documento, index) in documentos" :key="index" class="mb-2">
      <a
        v-if="documento.url_pdf || documento.url_word || documento.url_excel || documento.url_comprimido || documento.url_img"
        :href="urlServe + (documento.url_pdf || documento.url_word || documento.url_excel || documento.url_comprimido || documento.url_img)"
        target="_blank"
        class="link-text"
      >
        <div class="title_document" style="display: flex; justify-content: space-between;">
          <div class="col-9">
            <h5 style="font-weight: 400; color: #6c757d">{{ documento.titulo || 'Documento sin título' }}  <span style="font-size:0.8rem; font-weight: 400; color: #6c757d">{{documento.descripcion}}</span> </h5>
          </div>
          <!-- <div class="col-3">
            <p class="descargar">Descargar <i class="bx bx-download icono-down"></i></p>
          </div> -->
        </div>
      </a>
      <div v-else>
        <h5 class="mt-4" style="font-weight: bold; color: #000">{{ documento.titulo || 'Documento sin título' }}</h5>
      </div>
      <div v-if="documento.contenido && documento.contenido.length" >
        <ul style="list-style-type: none; padding: 0;">
          <li v-for="(contenido, contenidoIndex) in documento.contenido[0]" :key="contenidoIndex">
            <a v-if="contenido.link || contenido.url_pdf || contenido.url_word || contenido.url_excel || contenido.url_comprimido || contenido.url_img"
              :href="contenido.link || urlServe+contenido.url_pdf || urlServe+contenido.url_word || urlServe+contenido.url_excel || urlServe+contenido.url_comprimido || urlServe+contenido.url_img"
               target="_blank"
               class="link-text"
            >
              <div class="title_document mb-2" style="display: flex; justify-content: space-between;">
                <div class="col-9">
                  <h5 style="font-weight: 400; color: #6c757d">{{ contenido.titulo || 'Sin título' }}</h5>
                </div>
                <!-- <div class="col-3">
                  <p class="descargar">Descargar <i class="bx bx-download icono-down"></i></p>
                </div> -->
              </div>
            </a>
            <span v-else style="font-weight: 400; color: #6c757d">{{ contenido.titulo || 'Sin título' }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    documentos: {
      type: Array,
      required: true
    },
    urlServe: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.link-text {
  text-decoration: none;
}
.title_document h5 {
  font-size: 1rem !important;
}
.descargar {
  font-size: 1rem;
  color: #6c757d !important;
}
</style>
